import React from 'react';
import { Box, Button } from '@sparknz/spark-pattern-library';
import { LinkRegion } from '@sparknz/tracking';

import {
  MobilePlansDetails,
  RelatedOfferDetails,
} from 'components/shop/MobilePlans/typings/plans';
import { toPlanCardProduct } from 'components/shop/MobilePlans/utils/trackActionLayerViewEvent';
import { useAddToCart } from '../../../../hooks/useAddToCart/useAddToCart';
import { useTrackActionLayerView } from '../../../../hooks/useTrackActionLayerView';
import { SelectedPlans } from '../../../../SelectedPlansActionLayer';

interface ReviewSelectionStepProps {
  plans: RelatedOfferDetails[];
  planCardsProducts: MobilePlansDetails;
  onBack(): void;
}

const ReviewSelectionStep = ({
  plans,
  planCardsProducts,
  onBack,
}: ReviewSelectionStepProps) => {
  const transformedRelatedOffers = plans.map(toPlanCardProduct);
  const selectedPlanCardProducts = [
    planCardsProducts[0],
    ...transformedRelatedOffers,
  ];
  const { isAddingBundles, addSelectedPlansToCart } = useAddToCart(
    selectedPlanCardProducts as MobilePlansDetails,
  );

  useTrackActionLayerView({
    planDetails: selectedPlanCardProducts,
    eventName: 'Shop Companion Plans Selection Action Layer',
  });

  return (
    <LinkRegion regionId="addCompanionPlansActionLayer">
      <SelectedPlans
        planCardsProducts={selectedPlanCardProducts as MobilePlansDetails}
        hasTitle
        actions={
          <Box flexDirection="column" gap="s2">
            <Button
              variant="primary"
              onClick={addSelectedPlansToCart}
              isLoading={isAddingBundles}
              fullWidth
            >
              Add to cart
            </Button>
            <Button
              variant="default"
              onClick={onBack}
              disabled={isAddingBundles}
              fullWidth
            >
              Go back
            </Button>
          </Box>
        }
      />
    </LinkRegion>
  );
};

export default ReviewSelectionStep;
